import useHttp from './use-http';

const useContentApproval = () => {
    const hideOnboarding = (contactId) => {
        const url = `/api/v1/contacts/${contactId}/content-approval/hide-onboarding`;
        const { http } = useHttp();
        return http.patch(url);
    };

    return {
        hideOnboarding
    };
};

export default useContentApproval;
